export const FETCH_SET = {
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
};
